import { render } from "./ProRata.vue?vue&type=template&id=12034441"
import script from "./ProRata.vue?vue&type=script&lang=js"
export * from "./ProRata.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__